import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EnvironmentService } from '@tc/foundation';
import { LoggerService, Severity } from '@tc/logger';
import { AuthenticationService } from '@tc/security-oauth-legacy';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountService } from '../../../features/account/account.service';
import { PageLoaderService } from '../../../features/page-loader/page-loader.service';
import { InjectorService } from '../../services/injector.service';
import { IDropCatchConfiguration } from '../../../site/configuration/IDropCatchConfiguration';
import { UserAccount } from '../../../features/account/models/UserAccount';
import { PermissionService } from '@tc/permissions-legacy';

@Component({
  selector: 'base-feature',
  template: '',
  standalone: false,
})
export abstract class BaseFeatureComponent implements OnDestroy {
  protected name: string;
  protected destroyed$ = new Subject();
  protected loggingService: LoggerService;
  protected pageLoaderService: PageLoaderService;
  protected envService: EnvironmentService<IDropCatchConfiguration>;
  protected authService: AuthenticationService;
  protected accountService: AccountService;
  protected permissionsService: PermissionService;
  protected dialog: MatDialog;

  constructor() {
    const injector = InjectorService.getInjector();
    this.loggingService = injector.get(LoggerService);
    this.pageLoaderService = injector.get(PageLoaderService);
    this.envService = injector.get(EnvironmentService);
    this.authService = injector.get(AuthenticationService);
    this.accountService = injector.get(AccountService);
    this.permissionsService = injector.get(PermissionService);
    this.dialog = injector.get(MatDialog);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }

  protected handleError<T>(methodName: string, error: T, ...tags: string[]): void;
  protected handleError(methodName: string, message: string, ...tags: string[]): void;
  protected handleError<T>(methodName: string, errorOrMessage: T | string, ...tags: string[]): void {
    this.pageLoaderService.setLoader(false);
    this.loggingService.log(`${this.name}.${methodName}`, Severity.Error, { error: errorOrMessage }, tags);
  }

  protected getAccount(): Observable<UserAccount> {
    return this.accountService.account$.pipe(takeUntil(this.destroyed$));
  }

  protected getPermissions(): Observable<string[]> {
    return this.permissionsService.permissions$.pipe(takeUntil(this.destroyed$));
  }
}
